export const SUPPRESSED_ROUTES = [
    '/checkouts'
];
